export default function initContactForm() {
    window.addEventListener('load', function () {
        document.querySelectorAll('.contact-form').forEach($container => {
            const $category = $container.querySelectorAll('.category input');
            const $subCategory = $container.querySelectorAll('.sub-category input');
            const $categoryDivs = $container.querySelectorAll(':scope > div > div');
            const $submitContainer = $container.querySelectorAll('.dccs-form-actions');
            const allowedTypes = ['press', 'events', 'sustainability', 'sponsorships', 'procurement'];

            if ($category) {
                $category.forEach($radio =>
                    $radio.addEventListener('click', e => {
                        if (
                            e.target !== undefined &&
                            e.target !== null &&
                            e.target.dataset !== undefined &&
                            e.target.dataset !== null &&
                            e.target.dataset.redirect !== undefined &&
                            e.target.dataset.redirect !== null
                        ) {
                            window.location.href = e.target.dataset.redirect;
                        } else {
                            $categoryDivs.forEach($div => {
                                if (!$div.classList.contains('is-hidden') && !$div.classList.contains('category')) {
                                    $div.classList.add('is-hidden');
                                }
                                if (allowedTypes.includes($radio.value)) {
                                    $submitContainer[0].classList.remove('is-hidden');
                                } else {
                                    $submitContainer[0].classList.add('is-hidden');
                                }

                                if ($div.classList.contains($radio.value)) {
                                    $div.classList.remove('is-hidden');
                                    window.scrollTo({
                                        top: window.pageYOffset + $div.getBoundingClientRect().top - 16,
                                        behavior: 'smooth',
                                    });
                                }
                            });
                        }
                    })
                );

                $subCategory.forEach($radio =>
                    $radio.addEventListener('change', () => {
                        let $parentContainer = $radio.parentNode.parentNode.parentNode.parentNode;
                        const $subCategoryDivs = $parentContainer.querySelectorAll(':scope > div');

                        $subCategoryDivs.forEach($div => {
                            if (!$div.classList.contains('is-hidden') && !$div.classList.contains('sub-category')) {
                                $div.classList.add('is-hidden');
                            }
                            if (allowedTypes.includes($radio.value)) {
                                $submitContainer[0].classList.remove('is-hidden');
                            } else {
                                $submitContainer[0].classList.add('is-hidden');
                            }
                            if ($div.classList.contains($radio.value)) {
                                $div.classList.remove('is-hidden');
                            }
                        });
                    })
                );
            }
        });
    });
}
